export default __webpack_public_path__ + "static/media/341.ec397c85.jpg";